(function() {
  var RTS_PREFIX = '/collections/sample-sale';
  var isOnRtsPage = window.location.pathname.startsWith(RTS_PREFIX);
  var isOnRtsPdp  = isOnRtsPage && window.location.pathname.includes('/products/');

  var FF_WA_NUMBER       = '918179135113';
  var FF_CUTOFF_HOUR_IST = 14;

  function rewriteToCollectionUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      if (url.pathname.startsWith('/products/')) {
        url.pathname = RTS_PREFIX + url.pathname;
        return url.href;
      }
    } catch(e) {}
    return href;
  }

  function patchAllProductLinks() {
    if (!isOnRtsPage) return;
    document.querySelectorAll('a[ref="productCardLink"], .product-card__link').forEach(function(a) {
      var href = a.getAttribute('href') || '';
      if (href.startsWith('/products/')) a.href = rewriteToCollectionUrl(a.href);
    });
  }

  var filterTimer = null;
  function filterAndStyleRtsVariants() {
    if (!isOnRtsPage) return;
    document.querySelectorAll('.variant-option--buttons').forEach(function(fieldset) {
      fieldset.querySelectorAll('.variant-option__button-label').forEach(function(label) {
        var badge = label.querySelector('.variant-option__badge--ready');
        label.style.display = badge ? '' : 'none';
      });
    });
  }

  function scheduleFilter() {
    clearTimeout(filterTimer);
    filterTimer = setTimeout(filterAndStyleRtsVariants, 60);
  }

  document.addEventListener('click', function(e) {
    if (!isOnRtsPage) return;
    var anchor = e.target.closest('a[href]');
    if (anchor) {
      var href = anchor.getAttribute('href');
      if (href && href.startsWith('/products/')) anchor.href = rewriteToCollectionUrl(anchor.href);
      return;
    }
    patchAllProductLinks();
  }, true);

  function startCountdown() {
    var timeEl = document.getElementById('ff-countdown-time');
    var preEl  = document.getElementById('ff-cd-pre');
    var postEl = document.getElementById('ff-cd-post');
    if (!timeEl) return;

    function tick() {
      var now    = new Date();
      var utcMs  = now.getTime() + (now.getTimezoneOffset() * 60000);
      var ist    = new Date(utcMs + 19800000);
      var cutoff = new Date(ist);
      cutoff.setHours(FF_CUTOFF_HOUR_IST, 0, 0, 0);
      var diff = cutoff - ist;

      if (diff <= 0) {
        if (preEl)  preEl.textContent  = 'Next dispatch at ';
        timeEl.textContent             = '2:00 PM IST';
        if (postEl) postEl.textContent = ' tomorrow';
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      timeEl.textContent = h + 'h ' + (m < 10 ? '0' : '') + m + 'm ' + (s < 10 ? '0' : '') + s + 's';
    }
    tick();
    setInterval(tick, 1000);
  }

  var ffInventoryMap = {};

  function fetchRtsInventory(cb) {
    var el = document.getElementById('ff-rts-inventory');
    if (!el) { cb({}); return; }
    try {
      var data = JSON.parse(el.textContent.trim());
      var map = {};
      (data.variants || []).forEach(function(v) {
        if (v.qty >= 0) map[v.id] = v.qty;
      });
      cb(map);
    } catch(e) { cb({}); }
  }

  function updateStockBadge(variantId) {
    var badge    = document.getElementById('ff-rts-stock-badge');
    var countEl  = document.getElementById('ff-stock-count');
    var qty = ffInventoryMap[parseInt(variantId)];
    if (badge && countEl) {
      if (typeof qty === 'number' && qty > 0 && qty <= 5) {
        countEl.textContent = qty;
        badge.classList.add('ff-visible');
      } else {
        badge.classList.remove('ff-visible');
      }
    }
    return qty;
  }

  // RTS products commonly have "continue selling when out of stock" enabled so
  // low-stock badges/urgency messaging can be shown even at 0 on-hand units.
  // That means Shopify's own variant.available stays true at 0 qty, so the
  // theme's default add-to-cart disabled state (driven by variant.available)
  // never reflects true RTS stock. Enforce it here using the real inventory
  // count from the ff-rts-inventory JSON instead.
  function enforceRtsStockOnAddToCart(variantId) {
    var qty = ffInventoryMap[parseInt(variantId)];
    var isSoldOut = typeof qty === 'number' && qty <= 0;
    document.querySelectorAll('add-to-cart-component').forEach(function(component) {
      if (isSoldOut) {
        if (component.disable) component.disable();
        component.dataset.ffRtsSoldOut = 'true';
      } else if (component.dataset.ffRtsSoldOut === 'true') {
        delete component.dataset.ffRtsSoldOut;
        if (component.enable) component.enable();
      }
    });
  }

  function handleRtsVariantChange(variantId) {
    updateStockBadge(variantId);
    enforceRtsStockOnAddToCart(variantId);
    // Shopify's own section-rendering update (triggered by the same variant
    // change) resolves asynchronously and re-enables the button based on
    // variant.available. Re-assert the real-inventory override afterward so
    // it wins as the final state.
    setTimeout(function() { enforceRtsStockOnAddToCart(variantId); }, 400);
  }

  document.addEventListener('change', function(e) {
    if (!isOnRtsPdp) return;
    if (e.target.type === 'radio' && e.target.dataset.variantId) {
      handleRtsVariantChange(e.target.dataset.variantId);
    }
  });

  function injectRtsPdpFeatures() {
    if (!isOnRtsPdp) return;
    if (document.getElementById('ff-rts-stock-badge')) return;

    var title  = (document.querySelector('h1') || {}).textContent || 'this dress';
    var waText = encodeURIComponent('Hi! I\'m interested in ' + title.trim() + ' from FairyFrills Ready-to-Ship. Can you confirm availability?');
    var waUrl  = 'https://wa.me/' + FF_WA_NUMBER + '?text=' + waText;

    var upperHtml =
      '<div id="ff-rts-stock-badge" class="ff-rts-stock-badge">' +
        '<span>Hurry! Only <strong id="ff-stock-count">-</strong> left in this size</span>' +
      '</div>' +
      '<div class="ff-rts-countdown">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C2185B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' +
        '<span id="ff-cd-pre">Order in </span>' +
        '<span id="ff-countdown-time" class="ff-rts-countdown-time">...</span>' +
        '<span id="ff-cd-post"> for today\'s dispatch</span>' +
      '</div>';

    var trustHtml =
      '<div id="ff-rts-trust-strip" class="ff-rts-trust-strip">' +
        '<div class="ff-rts-trust-item">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C2185B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
          '<span>Ships within 24 hours of order</span>' +
        '</div>' +
        '<div class="ff-rts-trust-item">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C2185B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
          '<span>Handcrafted quality guarantee</span>' +
        '</div>' +
        '<div class="ff-rts-trust-item">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="#25D366" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' +
          '<a href="' + waUrl + '" target="_blank" rel="noopener">Chat on WhatsApp</a>' +
        '</div>' +
      '</div>';

    var picker = document.querySelector('variant-picker') || document.querySelector('.variant-picker');
    if (picker) {
      var upperEl = document.createElement('div');
      upperEl.innerHTML = upperHtml;
      picker.parentNode.insertBefore(upperEl, picker.nextSibling);
    }

    var buyBlock = document.querySelector('.buy-buttons-block') ||
                   document.querySelector('form[data-type="add-to-cart-form"]');
    if (buyBlock) {
      var lowerEl = document.createElement('div');
      lowerEl.innerHTML = trustHtml;
      buyBlock.parentNode.insertBefore(lowerEl, buyBlock.nextSibling);
    }

    startCountdown();

    fetchRtsInventory(function(map) {
      ffInventoryMap = map;
      setTimeout(function() {
        var params    = new URLSearchParams(window.location.search);
        var variantId = params.get('variant');
        if (!variantId) {
          var checked = document.querySelector('input[type="radio"]:checked[data-variant-id]');
          variantId = checked ? checked.dataset.variantId : null;
        }
        if (variantId) {
          updateStockBadge(variantId);
          enforceRtsStockOnAddToCart(variantId);
        }
      }, 300);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    patchAllProductLinks();
    filterAndStyleRtsVariants();
    injectRtsPdpFeatures();

    var observer = new MutationObserver(function() {
      patchAllProductLinks();
      scheduleFilter();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
